<div class="gdp-ai-assistant-table">
  <div class="vox-table dictionary-table">
    <table>
      <thead>
        <tr>
          <td translate>internal-facilities.ai-assistant.table.substitute.label</td>
          <td translate>internal-facilities.ai-assistant.table.replacement.label</td>
          <td translate>internal-facilities.ai-assistant.table.enabled.label</td>
          <td translate>internal-facilities.ai-assistant.table.actions.label</td>
        </tr>
      </thead>
      <tbody *ngIf="!_loading">
        <ng-container *ngFor="let d of dictionary; let i = index">
          <tr *ngIf="d._isUpdating">
            <td colspan="4">
              <ngx-skeleton-loader [theme]="{'margin-bottom': 0 }"></ngx-skeleton-loader>
            </td>
          </tr>
          <tr *ngIf="!d._isUpdating">
            <td>{{d.substitute}}</td>
            <td class="dictionary-table--vertical">
              <li *ngFor="let r of d.replacement_group">{{r}}</li>
            </td>
            <td>
              <gdp-status-icon [isEnabled]="d.enabled"></gdp-status-icon>
            </td>
            <td class="dictionary-table__actions">
              <div class="dictionary-table__actions--wrapper">
                <button class="vox-btn btn btn-warning" (click)="updatingDictionary(d)"
                [ngbTooltip]="'internal-facilities.ai-assistant.table.actions.edit' | translate">
                  <i class="icon-small-edit"></i>
                </button>
                <button class="vox-btn btn btn-danger" (click)="deleteDictionary(d, i)"
                [ngbTooltip]="'internal-facilities.ai-assistant.table.actions.delete' | translate">
                  <i class="icon-small-delete"></i>
                </button>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tbody *ngIf="_loading">
        <tr *ngFor="let i of [1,2,3,4]">
          <td colspan="4">
            <ngx-skeleton-loader [theme]="{'margin-bottom': 0}"></ngx-skeleton-loader>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!_loading && dictionary.length === 0">
        <tr>
          <td colspan="4" translate>internal-facilities.ai-assistant.table.empty</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>